import React, { useState, useRef, useEffect, useCallback } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { BaseUrl } from "../common/config";
import discountIcon from "../assets/images/discount-icon.png";
import { http } from "../helper";
import DataTable from "react-data-table-component";
import Sidebar from "../common/sidebar";
import moment from "moment";
import CommonAlert from "../common/Commonalert";
import Popup from "../common/popup";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { dateformatwithuktime } from "../utilityfunctions";
import * as XLSX from "sheetjs-style";
import { saveAs } from "file-saver";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";

function KitchenOrders() {
  const { t } = useTranslation();

  const RANGE_OPTIONS = [
    { value: "1", label: t("past_30_days_txt") },
    { value: "3", label: t("past_90_days_txt") },
    { value: "6", label: t("past_180_days_txt") },
    { value: "1Year", label: t("past_1_year_txt") },
    { value: "custom", label: t("custom_txt") },
  ];

  const CUSTOM_STYLES = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px",
      },
    },
    cells: {
      style: {
        padding: "8px",
      },
    },
  };

  const PAGINATION_COMPONENT_OPTIONS = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  const SELECT_THEME = (theme) => ({
    ...theme,
    borderRadius: 6,
    height: 40,
    colors: {
      ...theme.colors,
      primary25: "#e0dedb",
      primary: "#ec2f45",
    },
  });

  const initialState = {
    orders: [],
    temporders: [],
    priceBands: [],
    searchTextVal: "",
    loading: true,
    popupView: "",
    alertMessage: "",
    alertPopup: false,
    isElementVisible: false,
    datelabel: t("past_30_days_txt"),
    dateRange: "",
    datepickershow: false,
    datefrom: "",
    dateto: "",
    datefromLabel: "",
    datetoLabel: "",
    dateinvalid_error: false,
    datefill_error: false,
    searchstate: false,
    searchField: "OrderNumber",
    searchFieldtxt: t("order_number_txt"),
    notesPopup: false,
    note: "",
    currentOrder: [],
    orderlogs: [],
    noteError: false,
    isLoading: false,
    uploadMessage: "",
    showPopup: false,
    refreshLoading: false,
    trigerDateFilter: false,
    isFilterApplied: false,
    selectedDateOption: { value: "1", label: t("past_30_days_txt") },
    restrictedAccounts: [],
    suggestions: [],
    visibleAlert: false,
    visibleNoDataAlert: false,
  };

  const priceFormat = (price) => {
    if (price == null || isNaN(price)) {
      return t("price_placeholder_txt");
    }
    return price.toLocaleString("en-US", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  };

  const formatDate = (dateString) => {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  };

  const cleanProductName = (productName) => {
    if (productName !== "") {
      productName = productName.replaceAll("amp;", "&");
      productName = productName.replaceAll("apos;'", "'' ");
      productName = productName.replaceAll("quot;'", "'' ");
      return productName;
    }
    return productName;
  };

  const cleanOrderNotes = (orderNote) => {
    let noteText = orderNote.replaceAll(" PIXHALLCSL", "");
    noteText = noteText.replaceAll("amp;", "&");
    noteText = noteText.replaceAll("apos;", "'' ");
    noteText = noteText.replaceAll("apos;'", "'' ");
    noteText = noteText.replaceAll("quot;'", "'' ");
    noteText = noteText.replaceAll("quot;", "'' ");
    noteText = noteText.replaceAll("'' '", "'' ");
    return noteText;
  };

  const orderRecordsTotal = (orders, searchTextVal, searchFieldtxt) => {
    let totalOrderAmount = 0;
    let orderCount = 0;
    orders.forEach((order) => {
      orderCount++;
      if (searchTextVal.toLowerCase() === "orders placed") {
        if (order.OrderStatus !== "Cancelled") {
          totalOrderAmount +=
            order.OrderTotalWithVat !== undefined ? order.OrderTotalWithVat : 0;
        }
      } else if (
        searchFieldtxt === t("order_status_txt") &&
        searchTextVal === "Cancelled"
      ) {
        totalOrderAmount +=
          order.OrderTotalWithVat !== undefined ? order.OrderTotalWithVat : 0;
      } else if (order.OrderStatus !== "Cancelled") {
        totalOrderAmount +=
          order.OrderTotalWithVat !== undefined ? order.OrderTotalWithVat : 0;
      }
    });
    return {
      totalOrderAmount: priceFormat(totalOrderAmount),
      totalOrderCount: orderCount,
    };
  };

  const filterOrdersByField = (
    source,
    { searchField, searchFieldtxt, searchTextVal, includePriceBand },
  ) => {
    const lowercasedValue = searchTextVal.toLowerCase().trim();
    return source.filter((item) => {
      if (lowercasedValue === "orders placed") {
        return true;
      }
      if (
        Number.isInteger(Number(lowercasedValue)) &&
        searchFieldtxt === t("order_number_txt")
      ) {
        return item.OrderNumber.toLowerCase().includes(lowercasedValue);
      }
      if (
        lowercasedValue !== "a" &&
        lowercasedValue !== "k" &&
        searchFieldtxt === t("account_code_txt")
      ) {
        return item.accountCode.toLowerCase().includes(lowercasedValue);
      }
      if (includePriceBand && searchField === "PriceBand") {
        return (
          item.Priceband &&
          item.Priceband.toLowerCase()
            .replace(/\s+/g, "")
            .includes(lowercasedValue.replace(/\s+/g, ""))
        );
      }
      if (
        lowercasedValue !== "a" &&
        lowercasedValue !== "k" &&
        searchField === "OrderStatus"
      ) {
        return item.OrderStatus.toLowerCase().includes(lowercasedValue);
      }
      return false;
    });
  };

  const getLoginEmail = () => {
    const authData = sessionStorage.getItem("authData");
    return authData ? JSON.parse(authData).adminEmail : undefined;
  };

  const [state, setStateRaw] = useState(initialState);
  const searchFieldRef = useRef(null);
  const searchInputRef = useRef(null);
  const dropdownRef = useRef(null);
  const patchState = useCallback((partial) => {
    setStateRaw((prev) => ({
      ...prev,
      ...(typeof partial === "function" ? partial(prev) : partial),
    }));
  }, []);
  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  } else {
    const authData = sessionStorage.getItem("authData");
    const parsedAuthData = authData ? JSON.parse(authData) : null;
    if (
      parsedAuthData &&
      parsedAuthData !== "" &&
      !parsedAuthData.adminRole?.permissions?.includes("manage_orders")
    ) {
      window.location.href = "/unauthorized";
    }
  }

  function getAllOrders() {
    let dateval = "";
    let dateval2 = "";
    if (state.datefrom && state.dateto) {
      dateval = format(new Date(state.datefrom), "yyyy-MM-dd");
      dateval2 = format(new Date(state.dateto), "yyyy-MM-dd");
    }
    const payload = {
      orderdays:
        typeof state.dateRange === "number"
          ? state.dateRange
          : state.dateRange
            ? ""
            : 30,
      datefrom: dateval || "",
      dateto: dateval2 || "",
      from: "backend",
    };
    const URL = BaseUrl + "admin/kitchen-orders";
    const loginemail = getLoginEmail();
    http
      .post(URL, payload)
      .then((response) => {
        patchState((prev) => {
          const responseData =
            loginemail === "karthik@k2bsolutions.in"
              ? response.data.data
              : response.data.data.filter(
                  (order) =>
                    !prev.restrictedAccounts.includes(order.accountCode),
                );
          return {
            ...prev,
            orders: responseData,
            temporders: responseData,
            loading: false,
            alertPopup: false,
            alertMessage: "",
            refreshLoading: false,
            searchstate: false,
            searchField: "",
            searchFieldtxt: t("order_number_txt"),
            searchTextVal: "",
          };
        });
        document
          .querySelectorAll(".fa-refresh")
          .forEach((row) => row.classList.remove("fa-spin"));
      })
      .catch(() => {
        document
          .querySelectorAll(".fa-refresh")
          .forEach((row) => row.classList.remove("fa-spin"));
        patchState({
          alertPopup: true,
          loading: false,
          alertMessage: t("server_busy_txt"),
        });
      });
  }

  function getPriceBands() {
    const URL = BaseUrl + "admin/pricebands";
    http
      .get(URL)
      .then((response) => {
        patchState({ priceBands: response.data.data });
      })
      .catch((error) => {
        console.error("Error updating customer status:", error);
      });
  }

  function fetchRestrictedAccounts() {
    http
      .get(BaseUrl + "admin/accountcodelist")
      .then((res) => {
        const ids = res.data?.data?.map((acc) => acc.accountCode);
        patchState({ restrictedAccounts: ids || [] });
      })
      .catch((err) => {
        console.error("Failed to load restricted accounts", err);
      });
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        patchState({ isElementVisible: false });
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    getAllOrders();
    getPriceBands();
    fetchRestrictedAccounts();
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (state.trigerDateFilter) {
      applyOrderFilters();
      patchState({ trigerDateFilter: false });
    }
  }, [state.trigerDateFilter]);

  function clearTempFilterValues() {
    const currentDateLabel =
      state.datefromLabel && state.datetoLabel ? t("custom_txt") : state.datelabel;
    const selectedFilterOption = RANGE_OPTIONS.find(
      (range) => range.label === currentDateLabel,
    );
    if (selectedFilterOption && selectedFilterOption.label === t("custom_txt")) {
      patchState({
        datepickershow: true,
        selectedDateOption: selectedFilterOption,
        datefrom: state.datefromLabel,
        dateto: state.datetoLabel,
      });
    } else {
      patchState({
        datefrom: null,
        dateto: null,
        datepickershow: false,
        selectedDateOption: selectedFilterOption,
      });
    }
  }

  function clearforOpenFilter() {
    patchState({ isFilterApplied: false });
    clearTempFilterValues();
  }

  function openFilter() {
    patchState((prev) => ({ isElementVisible: !prev.isElementVisible }));
    clearforOpenFilter();
  }

  function handleApplyOrderFilters() {
    patchState({ trigerDateFilter: true });
  }

  function applyOrderFilters() {
    let dateinvalid = false;
    if (state.dateRange === "") {
      return;
    }
    patchState({
      isElementVisible: false,
      loading: true,
      alertPopup: false,
      dateinvalid_error: false,
      datefill_error: false,
    });
    let payload = { orderdays: state.dateRange, datefrom: "", dateto: "" };
    if (state.dateRange === "custom") {
      if (state.datefrom && state.dateto) {
        const dateval = format(new Date(state.datefrom), "yyyy-MM-dd");
        const dateval2 = format(new Date(state.dateto), "yyyy-MM-dd");
        patchState({
          datefromLabel: state.datefrom,
          datetoLabel: state.dateto,
          datefill_error: false,
        });
        payload = { orderdays: "", datefrom: dateval, dateto: dateval2 };
      } else {
        dateinvalid = true;
        patchState({
          datefill_error: true,
          isElementVisible: true,
          loading: false,
        });
      }
    } else {
      patchState({
        datelabel: state.selectedDateOption.label,
        datefromLabel: "",
        datetoLabel: "",
      });
      payload = { orderdays: state.dateRange, datefrom: "", dateto: "" };
    }
    if (dateinvalid) {
      return;
    }
    const URL = BaseUrl + "admin/kitchen-orders";
    const loginemail = getLoginEmail();
    http
      .post(URL, payload)
      .then((response) => {
        patchState((prev) => {
          const responseData =
            loginemail === "karthik@k2bsolutions.in"
              ? response.data.data
              : response.data.data.filter(
                  (order) =>
                    !prev.restrictedAccounts.includes(order.accountCode),
                );
          const nextOrders = prev.searchstate
            ? filterOrdersByField(responseData, {
                searchField: prev.searchField,
                searchFieldtxt: prev.searchFieldtxt,
                searchTextVal: prev.searchTextVal,
                includePriceBand: true,
              })
            : responseData;
          return {
            ...prev,
            orders: nextOrders,
            temporders: responseData,
            loading: false,
          };
        });
      })
      .catch((err) => {
        console.error("Error:", err);
        patchState({ loading: false });
      });
  }

  function clearFilterOrderSearch() {
    if (!state.isFilterApplied) {
      patchState({
        selectedDateOption: { value: "1", label: t("past_30_days_txt") },
        dateRange: 30,
        trigerDateFilter: true,
      });
    } else {
      clearTempFilterValues();
      patchState({ isFilterApplied: false });
    }
  }

  function handleFilterChange(e) {
    patchState({ isFilterApplied: true, selectedDateOption: e });
    if (e.value === "") {
      return;
    }
    let valueDates = "";
    if (e.value === "1") {
      valueDates = 30;
      patchState({ datepickershow: false });
    } else if (e.value === "3") {
      valueDates = 90;
      patchState({ datepickershow: false });
    } else if (e.value === "6") {
      valueDates = 180;
      patchState({ datepickershow: false });
    } else if (e.value === "1Year") {
      valueDates = 365;
      patchState({ datepickershow: false });
    } else if (e.value === "custom") {
      valueDates = "custom";
      patchState({ datepickershow: true });
    }
    patchState({ dateRange: valueDates, dateinvalid_error: false });
  }

  function DateChange(value, type) {
    patchState({ isFilterApplied: true });
    if (type === "from") {
      patchState({ datefrom: value, dateinvalid_error: false });
    } else if (type === "to") {
      const dateval = format(new Date(state.datefrom), "yyyy-MM-dd");
      const dateval2 = format(new Date(value), "yyyy-MM-dd");
      if (dateval > dateval2) {
        patchState({ dateto: "", dateinvalid_error: true });
      } else {
        patchState({ dateto: value, dateinvalid_error: false });
      }
    }
  }

  function handleReset() {
    patchState((prev) => ({
      orders: prev.temporders,
      searchstate: false,
      searchField: "",
      searchFieldtxt: t("order_number_txt"),
      searchTextVal: "",
    }));
    if (searchFieldRef.current) {
      searchFieldRef.current.selectedIndex = 1;
    }
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
  }

  function handlePriceBandChange(e) {
    const value = e.target.value;
    patchState({ searchTextVal: value, alertPopup: false, showPopup: false });
    if (value.trim() === "") {
      patchState({ suggestions: [] });
      return;
    }
    const suggestions = [
      ...new Set(
        state.priceBands.filter(
          (item) => item && item.toLowerCase().includes(value.toLowerCase()),
        ),
      ),
    ];
    patchState({ suggestions });
  }

  function handleChange(e) {
    const value = e.target.value;
    patchState({ searchTextVal: value });
    const filtered = filterOrdersByField(state.temporders, {
      searchField: state.searchField,
      searchFieldtxt: state.searchFieldtxt,
      searchTextVal: value,
      includePriceBand: false,
    });
    patchState({ orders: filtered, searchstate: true });
  }

  function filterData() {
    const filtered = filterOrdersByField(state.temporders, {
      searchField: state.searchField,
      searchFieldtxt: state.searchFieldtxt,
      searchTextVal: state.searchTextVal,
      includePriceBand: true,
    });
    patchState({ orders: filtered, alertPopup: false, searchstate: true });
  }

  function handleSearchFieldChange() {
    const selectedOption = searchFieldRef.current.selectedOptions[0];
    const value = searchFieldRef.current.value;
    const textval = selectedOption ? selectedOption.innerText : "";
    patchState({
      searchField: value,
      searchFieldtxt: textval,
      searchTextVal: "",
    });
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
  }

  function handleSuggestionClick(selectedValue) {
    if (searchInputRef.current) {
      searchInputRef.current.value = selectedValue;
    }
    const normalizedSelected = selectedValue.toLowerCase().replace(/\s+/g, "");
    const searchData = state.temporders.filter(
      (item) =>
        item.Priceband &&
        item.Priceband.toLowerCase().replace(/\s+/g, "") === normalizedSelected,
    );
    patchState({
      orders: searchData,
      suggestions: [],
      searchTextVal: selectedValue,
      searchstate: true,
    });
  }

  function renderSearchInput() {
    const searchField = searchFieldRef.current
      ? searchFieldRef.current.value
      : "";
    if (searchField === "OrderStatus") {
      return (
        <div className="orders-dropdown">
          <select
            className="search-ord"
            ref={searchInputRef}
            onChange={handleChange}
          >
            <option value="">{t("select_txt")}</option>
            <option value="Orders Placed">{t("orders_placed_txt")}</option>
            <option value="New Order">{t("new_order_txt")}</option>
            <option value="Acknowledged">{t("acknowledged_txt")}</option>
            <option value="Acknl  Being Picked">{t("acknl_being_picked_txt")}</option>
            <option value="Invoiced">{t("invoiced_txt")}</option>
            <option value="Part Desp.  Inv.">{t("part_desp_inv_txt")}</option>
            <option value="Cancelled">{t("cancelled_txt")}</option>
          </select>
        </div>
      );
    }
    if (searchField === "PriceBand") {
      return (
        <div>
          <input
            type="text"
            ref={searchInputRef}
            onChange={handlePriceBandChange}
            placeholder={`${t("searchby_txt")} ${state.searchFieldtxt}`}
          />
          {state.searchTextVal.trim() !== "" &&
            state.suggestions.length > 0 && (
              <ul className="suggestions-list">
                {state.suggestions.map((item, index) => (
                  <li key={index} onClick={() => handleSuggestionClick(item)}>
                    {item}
                  </li>
                ))}
              </ul>
            )}
        </div>
      );
    }
    return (
      <input
        type="text"
        ref={searchInputRef}
        onChange={handleChange}
        placeholder={`${t("searchby_txt")} ${state.searchFieldtxt}`}
      />
    );
  }

  function alertPopupclose() {
    patchState({ visibleAlert: false });
  }

  function handleConfirmExportToExcel() {
    if (!state.orders || state.orders.length === 0) {
      patchState({ visibleNoDataAlert: true });
      return;
    }
    patchState({ visibleAlert: true });
  }

  function handleCloseNoDataAlert() {
    patchState({ visibleNoDataAlert: false });
  }

  function handleExportToExcel() {
    const {
      orders,
      datefromLabel,
      datetoLabel,
      datelabel,
      searchTextVal,
      searchFieldtxt,
    } = state;
    const { totalOrderCount } = orderRecordsTotal(
      orders,
      searchTextVal,
      searchFieldtxt,
    );
    const dateRangeText =
      datefromLabel && datetoLabel
        ? `${t("from_txt")} ${formatDate(datefromLabel)} ${t("to_txt")} ${formatDate(datetoLabel)}`
        : datelabel;
    const firstRowText = `${t("total_records_txt")}: ${totalOrderCount} (${dateRangeText})`;
    const headers = [
      t("order#_number_txt"),
      t("account_code_txt"),
      t("account_name_txt"),
      t("email_address_txt"),
      t("price_band_txt"),
      t("ordered_date_txt"),
      t("delivery_date_txt"),
      t("status_txt"),
    ];
    const headerStyle = {
      font: { bold: true },
      alignment: { horizontal: "left" },
    };
    const styledHeaders = headers.map((text) => ({ v: text, s: headerStyle }));
    const rows = orders.map((order) => [
      order.OrderNumber,
      order.accountCode,
      order.accountName,
      order.accountEmail,
      order.Priceband,
      moment(order.createdAt).format("DD/MM/YYYY"),
      order.DateRequired,
      order.OrderStatus,
    ]);
    const worksheetData = [
      [
        {
          v: firstRowText,
          s: { font: { bold: true }, alignment: { horizontal: "left" } },
        },
      ],
      styledHeaders,
      ...rows,
    ];
    const columnWidths = headers.map((header, index) => {
      let maxLength = header.length;
      rows.forEach((row) => {
        maxLength = Math.max(maxLength, String(row[index]).length);
      });
      return { wch: maxLength + 2 };
    });
    const ws = XLSX.utils.aoa_to_sheet(worksheetData);
    ws["!merges"] = [
      {
        s: { r: 0, c: 0 },
        e: { r: 0, c: headers.length - 1 },
      },
    ];
    ws["!cols"] = columnWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, t("kitchen_orders_txt"));
    const exportDateTime = moment().format("DD-MM-YYYY");
    const fileName = `${t("kitchen_order_report_txt")}-${exportDateTime}.xlsx`;
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    saveAs(blob, fileName);
    patchState({ visibleAlert: false });
  }

  function orderRefresh(order) {
    let numberOfAjaxCAllPending = 0;
    const timeInterval = 20000;
    const element = document.getElementById(
      "refresh_order_id" + order.OrderNumber,
    );
    element.classList.add("fa-spin");
    patchState({ alertPopup: false });
    const URL =
      BaseUrl +
      "admin/updatekitchenorderitems/" +
      order.accountCode +
      "/" +
      order.OrderNumber;
    http
      .get(URL)
      .then((response) => {
        numberOfAjaxCAllPending++;
        const responseData = response.data.data[0];
        patchState((prev) => {
          const updatedOrders = prev.orders.map((o) =>
            o.OrderNumber === responseData.OrderNumber ? responseData : o,
          );
          const updatedTemporders = prev.temporders.map((o) =>
            o.OrderNumber === responseData.OrderNumber ? responseData : o,
          );
          const nextOrders = prev.searchstate
            ? filterOrdersByField(updatedTemporders, {
                searchField: prev.searchField,
                searchFieldtxt: prev.searchFieldtxt,
                searchTextVal: prev.searchTextVal,
                includePriceBand: true,
              })
            : updatedOrders;
          return {
            ...prev,
            orders: nextOrders,
            temporders: updatedTemporders,
            alertPopup: false,
            alertMessage: "",
            loading: false,
          };
        });
        element.classList.remove("fa-spin");
        clearInterval(myInterval);
      })
      .catch((err) => {
        console.error(err);
        patchState({
          alertPopup: true,
          alertMessage: t("server_busy_txt"),
        });
      });
    const myInterval = setInterval(() => {
      if (numberOfAjaxCAllPending === 0) {
        numberOfAjaxCAllPending++;
        patchState({
          alertPopup: true,
          alertMessage: t("server_busy_txt"),
        });
      }
    }, timeInterval);
  }

  function viewOrderDetails(order) {
    patchState({ alertPopup: false, alertMessage: "" });
    const sortedItems = [...order.items].sort((a, b) => {
      if (a.UnitPrice === 0 && b.UnitPrice !== 0) return 1;
      if (a.UnitPrice !== 0 && b.UnitPrice === 0) return -1;
      if (a.ProductNumber === "77775" && b.ProductNumber !== "77775") return 1;
      if (b.ProductNumber === "77775" && a.ProductNumber !== "77775") return -1;
      return 0;
    });
    const popupResult = (
      <Popup
        extClass="order-pop my-order-details-pop"
        headMoreTxt={
          <div className="order-top">
            <div className="bottom order-flex">
              <div className="order_no_details">
                <h3>{t("order_no_txt")} - {order.OrderNumber}</h3>
                <p>
                  {t("order_placed_on_txt")}:{" "}
                  <span className="date">
                    {" "}
                    {moment(order.createdAt).format("DD/MM/YYYY hh:mm A")}
                  </span>{" "}
                </p>
                <p>
                  {t("order_deleivery_on_txt")}:{" "}
                  <span className="date"> {order.DateRequired} </span>
                </p>
                <p>
                  {t("status_txt")}:<span className="pay"> {order.OrderStatus}</span>
                </p>
              </div>
              <div className="order_account_details">
                <p>
                  {t("name_txt")}: <span className="date">{order.accountName}</span>{" "}
                </p>
                <p>
                  {t("account_code_txt")}:{" "}
                  <span className="date">{order.accountCode}</span>{" "}
                </p>
                <p>
                  {t("email_address_txt")}:{" "}
                  <span className="pay">{order.accountEmail}</span>
                </p>
                <p>
                  {t("address_txt")}: <span className="pay">{order.accountAddress}</span>
                </p>
                {order.PODetails && (
                  <p>
                    {t("po_details_txt")}: <span className="pay">{order.PODetails}</span>
                  </p>
                )}
                <p>
                  {t("price_band_txt")}:{" "}
                  <span className="date">{order.Priceband}</span>{" "}
                </p>
              </div>
            </div>
          </div>
        }
        closebtn={
          <div className="pop-header-top order-top">
            <div className="head">
              <h4>{t("kitchen_order_details_txt")} - {order.OrderNumber}</h4>
            </div>
            <span
              onClick={() => patchState({ popupView: "" })}
              className="close"
            ></span>
          </div>
        }
        bodyMoreTxt={
          <>
            <div className="modal-table">
              <h4 className="item-title">{t("ordered_items_txt")}</h4>
              <div className="checkout-table">
                <div className="table_overflow">
                  <table>
                    <thead>
                      <tr>
                        <td>{t("product_txt")}</td>
                        <td>{t("unit_of_sale_txt")}</td>
                        <td>{t("quantity_txt")}</td>
                      </tr>
                    </thead>
                    <tbody>
                      {sortedItems.map(
                        (item, index) =>
                          item.QuantityOrdered > 0 && (
                            <tr
                              key={index}
                              className={
                                item.productType === "Free" ||
                                item.productType === "CH"
                                  ? "free-prod-bg"
                                  : ""
                              }
                            >
                              <td
                                data-title={t("product_txt")}
                                className="data-product-hide"
                              >
                                {cleanProductName(item.Description)} (
                                {item.ProductNumber.includes("_")
                                  ? item.ProductNumber.substring(
                                      0,
                                      item.ProductNumber.indexOf("_"),
                                    )
                                  : item.ProductNumber}
                                )
                                {item.TaxCode !== "" &&
                                  item.TaxCode === "T1" && (
                                    <span className="color-red">*</span>
                                  )}
                                {item.OfferFlag == "true" && (
                                  <span className="offer-tag-wrap">
                                    <span className="offer-tag">
                                      <img
                                        src={discountIcon}
                                        alt={t("offer_txt")}
                                        className="tag-icon"
                                      />
                                      {t("special_offer_txt")}
                                    </span>
                                  </span>
                                )}
                              </td>
                              <td data-title={t("unit_of_sale_txt")}>
                                {item.PricingUnit}
                              </td>
                              <td data-title={t("quantity_txt")}>
                                {item.QuantityOrdered}
                              </td>
                            </tr>
                          ),
                      )}
                    </tbody>
                    <thead className="ord-grand-total">
                      {order.OrderNote !== "" && order.OrderNote !== null && (
                        <tr>
                          <td align="left" width={120} colSpan="7">
                            {t("order_notes_txt")}:{" "}
                            <span className="order_remarks">
                              {" "}
                              {cleanOrderNotes(order.OrderNote)}
                            </span>
                          </td>
                        </tr>
                      )}
                    </thead>
                  </table>
                </div>
              </div>
            </div>
            {order.OrderDiscount > 0 && (
              <span className="tot-ofr-applied">
                {t("order_discount_applied")
                  .replace("{discount}", order.OrderDiscount)}
              </span>
            )}
            <span className="tot-ofr-applied">
              {t("kitchen_order_note_txt")}
            </span>
          </>
        }
      />
    );
    patchState({ popupView: popupResult });
  }

  function getOrderaccountdetails(accountCode, orderrow) {
    const loadingPopup = (
      <Popup
        extClass="order-pop"
        headMoreTxt={
          <div className="order-top">
            <div className="bottom order-flex">
              <div className="order_no_details">
                <h3>{t("order_no_txt")} - {orderrow.OrderNumber}</h3>
                <p>
                  {t("order_placed_on_txt")}:{" "}
                  <span className="date">
                    {" "}
                    {moment(orderrow.createdAt).format("DD/MM/YYYY hh:mm A")}
                  </span>{" "}
                </p>
                <p>
                  {t("order_deleivery_on_txt")}:{" "}
                  <span className="date"> {orderrow.DateRequired} </span>
                </p>
                <p>
                  {t("status_txt")}:
                  <span className="pay"> {orderrow.OrderStatus}</span>
                </p>
              </div>
              <div className="order_account_details">
                <p>
                  {t("name_txt")}:{" "}
                  <span className="date">{orderrow.accountName}</span>{" "}
                </p>
                <p>
                  {t("account_code_txt")}:{" "}
                  <span className="date">{orderrow.accountCode}</span>{" "}
                </p>
                <p>
                  {t("email_address_txt")}:{" "}
                  <span className="pay">{orderrow.accountEmail}</span>
                </p>
                <p>
                  {t("address_txt")}:{" "}
                  <span className="pay">{orderrow.accountAddress}</span>
                </p>
                {orderrow.PODetails && (
                  <p>
                    {t("po_details_txt")}:{" "}
                    <span className="pay">{orderrow.PODetails}</span>
                  </p>
                )}
              </div>
            </div>
          </div>
        }
        closebtn={
          <div className="order-top">
            <div className="head">
              <h4>{t("kitchen_order_details_txt")} - {orderrow.OrderNumber}</h4>
            </div>
            <span
              onClick={() => patchState({ popupView: "" })}
              className="close"
            ></span>
          </div>
        }
        bodyMoreTxt={
          <div className="modal-table">
            <h4 className="item-title">{t("ordered_items_txt")}</h4>
            <div className="checkout-table">
              <div className="table_overflow">
                <table>
                  <tbody>
                    <tr>
                      <td colSpan={5} className="is-loading">
                        <div>
                          <p></p>
                          <p></p>
                          <p></p>
                          <p></p>
                          <p></p>
                          <p></p>
                          <p></p>
                          <p></p>
                          <p></p>
                          <p></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        }
      />
    );
    patchState({ popupView: loadingPopup, alertPopup: false, loading: true });
    const URL =
      BaseUrl +
      "admin/updatekitchenorderitems/" +
      accountCode +
      "/" +
      orderrow.OrderNumber;
    http
      .get(URL)
      .then((response) => {
        const responseData = response.data.data[0];
        patchState({ loading: false });
        viewOrderDetails(responseData);
      })
      .catch(() => {
        patchState({ loading: false });
      });
  }

  function orderNotelog(order) {
    patchState({ isLoading: true, notesPopup: true, currentOrder: order });
    const URL = BaseUrl + "admin/orderlog/" + order.OrderNumber;
    http
      .get(URL)
      .then((response) => {
        patchState({
          isLoading: false,
          orderlogs: response.data.data,
          notesPopup: true,
        });
      })
      .catch((error) => {
        patchState({ isLoading: false });
        console.error("Error getting status:", error);
      });
  }

  function hideNotePopup() {
    patchState({
      notesPopup: false,
      noteError: false,
      orderlogs: "",
      note: "",
    });
  }

  function handleNoteChange(value) {
    patchState({ note: value.trim(), noteError: false });
  }

  function updateNoteLog() {
    if (state.note.trim() === "") {
      patchState({ noteError: true });
      return;
    }
    const authData = sessionStorage.getItem("authData");
    const loginDetails = authData ? JSON.parse(authData) : {};
    const noteURL = BaseUrl + "admin/orderlog";
    const notepayload = {
      orderID: state.currentOrder.OrderNumber,
      noteText: state.note,
      createdBy: loginDetails.adminName,
    };
    patchState({ isLoading: true });
    http
      .post(noteURL, notepayload)
      .then(() => {
        patchState({
          notesPopup: false,
          isLoading: false,
          showPopup: true,
          uploadMessage: t("order_note_submit_success_txt"),
        });
      })
      .catch((error) => {
        patchState({ isLoading: false });
        console.error("Error submitting note:", error);
      });
  }

  function closePopup() {
    patchState({ showPopup: false, uploadMessage: "" });
  }

  const columns = [
    {
      name: t("order#_number_txt"),
      selector: (row) => row.OrderNumber,
      sortable: true,
    },
    {
      name: t("account_code_txt"),
      selector: (row) => row.accountCode,
      sortable: true,
    },
    {
      name: t("ordered_date_txt"),
      selector: (row) => moment(row.createdAt).format("DD/MM/YYYY"),
      sortable: false,
    },
    {
      name: t("delivery_date_txt"),
      selector: (row) => row.DateRequired,
      sortable: true,
      sortFunction: (a, b) => {
        const parseDate = (dateStr) => {
          const [day, month, year] = dateStr.split("/").map(Number);
          return new Date(year, month - 1, day);
        };
        return parseDate(a.DateRequired) - parseDate(b.DateRequired);
      },
    },
    {
      name: t("status_txt"),
      selector: (row) => row.OrderStatus,
      sortable: true,
    },
    {
      name: t("actions_txt"),
      selector: (row) => (
        <div className="order-action-tbl">
          {canAction("manage_orders", "view") && (
            <a
              className="title-tooltip title-up button"
              data-title={t("view_details_txt")}
              style={{ color: "white" }}
              onClick={() => getOrderaccountdetails(row.accountCode, row)}
            >
              <i className="fa fa-eye" aria-hidden="true"></i>
            </a>
          )}
          {canAction("manage_orders", "logs") && (
            <a
              className="button title-tooltip title-up"
              data-title={t("order_note_log_txt")}
              onClick={() => orderNotelog(row)}
            >
              <i className="fa fa-history"></i>
            </a>
          )}
          {canAction("manage_orders", "refresh") && (
            <a
              className="refresh-btn title-tooltip title-up"
              data-title={t("updated_status_of_order_txt")}
              onClick={() => orderRefresh(row)}
            >
              <i
                className="fa fa-refresh"
                id={"refresh_order_id" + row.OrderNumber}
                aria-hidden="true"
              ></i>{" "}
            </a>
          )}
        </div>
      ),
      sortable: false,
    },
  ];

  const nodatacomponent =
    state.searchstate === false ? (
      state.datefromLabel && state.datetoLabel ? (
        <div className="no-records-found">
          {t("no_order_records_date_range")
            .replace("{from}", formatDate(state.datefromLabel))
            .replace("{to}", formatDate(state.datetoLabel))}
        </div>
      ) : (
        <div className="no-records-found">
          {t("no_order_records_date").replace(
            "{date}",
            state.datelabel
          )}
        </div>
      )
    ) : (
      <div className="no-records-found">
        {t("no_orders_matching_keyword")}
      </div>
    );

  return (
    <>
      {state.alertPopup === true && (
        <CommonAlert title={t("alert_txt")} message={state.alertMessage} />
      )}
      <section className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <div className="cart-block">
            <div className="container">
              <div className="flex-title">
                <h1 className="checkout-title">{t("kitchen_orders_txt")}</h1>
                <div className="prod-import-btn odr-expo-btn">
                  <a href="orders">
                    <button type="button" title="Back">
                      {t("back_btn_txt")}
                    </button>
                  </a>
                  {canAction("manage_orders", "export") && (
                    <a
                      data-title={t("export_filtered_records")}
                      className="export-btn button title-tooltip title-left"
                      onClick={handleConfirmExportToExcel}
                    >
                      {t("export_btn_txt")}
                    </a>
                  )}
                </div>
              </div>
              <div className="right-table-outer-wrap">
                <div className="table-filter search-orders orders-search-bx">
                  <div className="orders-drop-left">
                    <div className="orders-dropdown">
                      <select
                        className="handle-srch"
                        ref={searchFieldRef}
                        onChange={handleSearchFieldChange}
                      >
                        <option value="" disabled>
                          {t("searchby_field_txt")}
                        </option>
                        <option value="OrderNumber">{t("order_number_txt")}</option>
                        <option value="OrderStatus">{t("order_status_txt")}</option>
                        <option value="accountCode">{t("account_code_txt")}</option>
                        <option value="PriceBand">{t("price_band_txt")}</option>
                      </select>
                    </div>
                    <div className="table-search-reset">
                      <div className="table-search">{renderSearchInput()}</div>
                      <button
                        className="submitbtn button search-ord-btn"
                        onClick={filterData}
                      >
                        <i className="fa fa-search"></i>
                      </button>
                      <button
                        className="resetbtn"
                        type="reset"
                        onClick={handleReset}
                      >
                        {t("reset_txt")}
                      </button>
                    </div>
                  </div>
                  <div className="select-drop" ref={dropdownRef}>
                    <a
                      className={
                        state.isElementVisible === true
                          ? "filter-btn button active"
                          : "filter-btn button"
                      }
                      onClick={openFilter}
                    >
                      {t("more_filter_txt")}{" "}
                      <span className="filter-icon">
                        <i className="fa fa-sliders" aria-hidden="true"></i>
                      </span>
                    </a>
                    <div
                      className={
                        state.isElementVisible === true
                          ? "filter-bx show"
                          : "filter-bx"
                      }
                    >
                      <div className="filter-date-range">
                        <div className="fltr-dt-wrap">
                          <label>{t("date_range_txt")}:</label>
                          <Select
                            value={state.selectedDateOption}
                            options={RANGE_OPTIONS}
                            theme={SELECT_THEME}
                            onChange={handleFilterChange}
                          />
                        </div>
                      </div>
                      <div
                        className={
                          state.datepickershow === true
                            ? "fltr-dt-range show"
                            : "fltr-dt-range"
                        }
                      >
                        <div className="fltr--date">
                          <span>{t("from_txt")}</span>
                          <DatePicker
                            selected={state.datefrom}
                            placeholderText={t("select_date_txt")}
                            showDisabledMonthNavigation
                            dateFormat="dd/MM/yyyy"
                            disablePast={true}
                            maxDate={new Date()}
                            onChange={(date) => DateChange(date, "from")}
                          />
                          <span className="date-icon">
                            <i
                              className="fa fa-calendar"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </div>
                        <div className="fltr--date">
                          <span>{t("to_txt")}</span>
                          <DatePicker
                            selected={state.dateto}
                            placeholderText={t("select_date_txt")}
                            showDisabledMonthNavigation
                            dateFormat="dd/MM/yyyy"
                            disablePast={true}
                            maxDate={new Date()}
                            onChange={(date) => DateChange(date, "to")}
                          />
                          <span className="date-icon">
                            <i
                              className="fa fa-calendar"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </div>
                      </div>
                      {state.dateinvalid_error === true && (
                        <span className="color-red">
                          {t("invalid_start_end_date_txt")}
                        </span>
                      )}
                      {state.datefill_error === true && (
                        <span className="color-red">
                          {t("fill_from_to_date_txt")}
                        </span>
                      )}
                      <div className="filter-btns">
                        <button
                          type="button"
                          className="button clear-btn"
                          onClick={clearFilterOrderSearch}
                        >
                          {t("clear_txt")}
                        </button>
                        <button
                          type="button"
                          className="button apply-btn"
                          onClick={handleApplyOrderFilters}
                        >
                          {t("apply_txt")}{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {state.orders.length > 0 && state.loading === false && (
                  <p className="admin-order account-total-records">
                    {t("total_records_txt")}:{" "}
                    {state.orders.length > 0
                      ? orderRecordsTotal(
                          state.orders,
                          state.searchTextVal,
                          state.searchFieldtxt,
                        ).totalOrderCount
                      : ""}
                    {state.datefromLabel && state.datetoLabel ? (
                      <span>
                        {" "}
                        (From {formatDate(state.datefromLabel)} to{" "}
                        {formatDate(state.datetoLabel)})
                      </span>
                    ) : state.datelabel ? (
                      ` (${state.datelabel})`
                    ) : (
                      ""
                    )}
                  </p>
                )}
                <div className="checkout-table table_overflow orders-table">
                  <DataTable
                    columns={columns}
                    noDataComponent={nodatacomponent}
                    data={state.orders}
                    customStyles={CUSTOM_STYLES}
                    pagination
                    paginationPerPage={25}
                    progressPending={state.loading}
                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                    paginationComponentOptions={PAGINATION_COMPONENT_OPTIONS}
                  />
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
        {state.popupView}
      </section>
      {state.notesPopup && (
        <Popup
          extClass="info-poup show"
          closebtn={<span onClick={hideNotePopup} className="close"></span>}
          headMoreTxt={
            <div className="order-top">
              <h4>
                <span>{t("notes_for_order_txt")} - {state.currentOrder.OrderNumber}</span>
              </h4>
            </div>
          }
          bodyMoreTxt={
            <div className="bottom vendor-details ordernotes-log">
              <div className="order-notes">
                <div className="input-field">
                  <label htmlFor="note-label">{t("enter_your_note_txt")}</label>
                  <textarea
                    name="note"
                    onChange={(e) => handleNoteChange(e.target.value)}
                  ></textarea>
                  {state.noteError && (
                    <div className="err-msg">{t("update_note_txt")}</div>
                  )}
                </div>
              </div>
              <div className="alert-buttons btn-field btn-center">
                <button
                  onClick={updateNoteLog}
                  className="popup-alert-btn button"
                >
                  {t("submit_txt")}
                </button>
                <button
                  onClick={hideNotePopup}
                  className="popup-alert-btn button"
                >
                  {t("cancel_txt")}
                </button>
              </div>
              {state.isLoading ? (
                <div className="loading-buffer"></div>
              ) : (
                <div className="order-notes-log">
                  {state.orderlogs &&
                    state.orderlogs.length > 0 &&
                    state.orderlogs.map((ord_item, index) => (
                      <div className="info-item" key={index}>
                        <div className="info-innr">
                          <p>
                            <span className="labeltxt">{t("date_txt")}: </span>
                            {dateformatwithuktime(ord_item.createdAt)}
                          </p>
                          <p>
                            <span className="labeltxt log-reason">{t("note_txt")}</span>
                            {ord_item.noteText}
                          </p>
                          <p>
                            <span className="labeltxt log-reason">
                              {t("created_by_txt")}:{" "}
                            </span>
                            {ord_item.createdBy}
                          </p>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          }
        />
      )}
      {state.showPopup && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{state.uploadMessage}</p>
                <div className="alert-buttons">
                  <button
                    onClick={closePopup}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {state.refreshLoading && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-body alert-no-header">
                <div className="fth-latest-orders-alert">
                  <h4>{t("fetching_latest_order_txt")}</h4>
                  <p>
                    <i className="fa fa-spinner spin" aria-hidden="true"></i>{" "}
                    {t("wait_fetch_order_txt")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {state.visibleAlert === true && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("confirm_export_order_report_txt")}</p>
                <div className="alert-buttons">
                  <a
                    onClick={handleExportToExcel}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    onClick={alertPopupclose}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {state.visibleNoDataAlert && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("no_records_for_export_txt")}</p>
                <div className="alert-buttons">
                  <a
                    onClick={handleCloseNoDataAlert}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default KitchenOrders;
